import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/trip/$tripId/map')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/trip/$tripId/itinerary',
      params: { tripId: params.tripId },
      search: { mode: 'map' },
    });
  },
});
